const DarkerLine = () => {
    return <svg width="2" height="206" viewBox="0 0 2 206" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line x1="1" y1="3.38609e-08" x2="0.999988" y2="206" stroke="#3D8D4F" strokeOpacity="0.3" strokeWidth="2"/>
    </svg>
}

export default DarkerLine;
